import { Skeleton } from "@vega-core/components/shadcn/skeleton";

const SKELETON_ROWS = ["row-1", "row-2", "row-3", "row-4"];

export const FAQListSkeleton = () => (
  <div className="flex w-full flex-col gap-3" data-testid="faq-list-skeleton">
    {SKELETON_ROWS.map((rowKey) => (
      <Skeleton className="h-14 w-full rounded-lg" key={rowKey} />
    ))}
  </div>
);
